module.exports = __webpack_public_path__ + "static/media/listing-page-shimla.6c85dd6a.jpg";